var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewsWithNewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "10 5 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44014 16.2139C8.44014 17.5076 7.56061 17.8594 7.12085 17.8736H17.7177C18.8412 17.8736 19.2072 16.7671 19.2498 16.2139V7.9151C19.2498 6.38302 18.1149 6 17.5475 6H10.2701C8.77209 6 8.42595 7.27673 8.44014 7.9151V16.2139Z",
    stroke: "#585C6F",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.3979,
    y: 10.1719,
    width: 7.40504,
    height: 1.19162,
    rx: 0.595808
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9941,
    y: 12.6406,
    width: 2.80881,
    height: 1.19162,
    rx: 0.595808
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9941,
    y: 14.7676,
    width: 2.80881,
    height: 1.19162,
    rx: 0.595808
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3979,
    y: 12.6406,
    width: 3.57485,
    height: 3.3195,
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3979,
    y: 7.70312,
    width: 7.40504,
    height: 1.19162,
    rx: 0.595808
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68335 9.86523L6.68335 15.6652C6.68335 16.1991 6.25056 16.6319 5.71668 16.6319C5.18281 16.6319 4.75001 16.1991 4.75001 15.6652L4.75001 11.7986C4.75001 10.7308 5.6156 9.86523 6.68335 9.86523Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 17,
    r: 3.75,
    fill: "#0088E9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsWithNewIcon);
export default __webpack_public_path__ + "static/media/news-with-new-icon.03822592.svg";
export { ForwardRef as ReactComponent };